// 5 minutes
export const MAX_AUDIO_LENGTH = 2 * 60;
export const MARKETING_DOMAIN_URL = "https://talegacyremembered.com";
